// extracted by mini-css-extract-plugin
export const heading = "contributing-experts-module--heading--2KQLj";
export const mobileHeading = "contributing-experts-module--mobile-heading--Xy9an";
export const secondaryHeading = "contributing-experts-module--secondary-heading--2oxZB";
export const circleImage = "contributing-experts-module--circle-image--AidhB";
export const mobileTabletCircleImage = "contributing-experts-module--mobile-tablet-circle-image--1gj1c";
export const imageEnd = "contributing-experts-module--image-end--3Ykjf";